
import { Stage, KpiStrip, BlockHead, ExpandTable, Explica, Detalhe } from "../components/primitives";

const ETAPAS_SKILL = [
  {
    num: "01",
    titulo: "Descoberta de Leads",
    desc: "WebSearch em Instagram, sites e diretórios. Critérios: perfil ativo, site próprio ou LP, atendimento particular. Seleciona 8–10 candidatos.",
  },
  {
    num: "02",
    titulo: "Auditoria Digital Individual",
    desc: "Para cada um dos 5 melhores: Google Meu Negócio (nota, reviews, fotos), Site (CTA, pixel Meta, mobile), Instagram (frequência, reels, engajamento) e Biblioteca de Anúncios do Meta.",
  },
  {
    num: "03",
    titulo: "Score 0–10",
    desc: "Presença digital fraca (+3), Instagram com potencial (+3), Meta Ads ausente ou ruim (+2), solvência aparente (+2). Justificativa escrita para cada score.",
  },
  {
    num: "04",
    titulo: "Script de Abordagem Personalizado",
    desc: "WhatsApp ou DM com gancho baseado em algo real do perfil. Tom: colega de área, não vendedor. CTA único: 15 minutos de conversa.",
  },
  {
    num: "05",
    titulo: "Arquivos de Output",
    desc: "Um .md por lead (dr-sobrenome-score-status.md) + resumo semanal com ranking e checklist de abordagem.",
  },
];

const SCORES = [
  { range: "8–10", label: "Quente", cor: "var(--danger)", desc: "Prioridade máxima — abordar essa semana" },
  { range: "5–7",  label: "Morno",  cor: "var(--warn)",   desc: "Vale abordar, menos urgente" },
  { range: "0–4",  label: "Frio",   cor: "var(--muted)", desc: "Baixo potencial no momento" },
];

const PRE_ABORDAGEM = [
  {
    ordem: "1",
    acao: "Leia o arquivo completo do lead",
    detalhe: "Score, auditoria, pontos fracos e fortes. Não mande script sem ler o contexto — vai parecer genérico.",
  },
  {
    ordem: "2",
    acao: "Confira o Instagram na hora",
    detalhe: "Veja o último post publicado e use algo específico no gancho. Um detalhe recente mostra que você realmente pesquisou.",
  },
  {
    ordem: "3",
    acao: "Verifique se já existe contato anterior",
    detalhe: "Busque o nome na Agenda e no histórico de clientes. Evite abordar como novo quem já recusou.",
  },
  {
    ordem: "4",
    acao: "Ajuste o script se algo mudou",
    detalhe: "Se o lead começou a rodar anúncios desde a auditoria, o gancho muda. Nunca copie e cole sem verificar.",
  },
  {
    ordem: "5",
    acao: "Escolha o canal certo",
    detalhe: "WhatsApp se tiver número visível no perfil ou site. DM Instagram se não tiver — mas só se o perfil for público e ativo.",
  },
  {
    ordem: "6",
    acao: "Revise as regras CFM",
    detalhe: "Zero promessas de resultado clínico, zero antes/depois, zero cura. O script fala sobre crescimento digital, não sobre medicina.",
  },
  {
    ordem: "7",
    acao: "Envie no horário certo",
    detalhe: "Dias úteis, entre 8h e 18h. Evite segunda de manhã (cheio de mensagens) e sexta à tarde (desligado do trabalho).",
  },
  {
    ordem: "8",
    acao: "Registre a abordagem no resumo semanal",
    detalhe: "Marque o checkbox no arquivo resumo-semana-[DATA].md. Sem registro, não tem follow-up.",
  },
];

const MONO = {
  background: "var(--surface-2)", borderRadius: 12, padding: "10px 14px",
  fontFamily: "var(--font-data)", fontSize: 12, color: "var(--ink)", lineHeight: 1.8,
  border: "1px solid var(--line)", overflowX: "auto",
};

export function ProspectView() {
  return (
    <div className="view" style={{ maxWidth: 1000 }}>

      {/* Palco */}
      <Stage
        path="prospect"
        title="Prospect de"
        hl="leads"
        lead="Leads médicos da semana com auditoria digital, score de prioridade e script de abordagem, gerados pela skill prospectar-leads-medicos."
      />

      {/* O que sai da skill, em faixa */}
      <KpiStrip items={[
        { label: "Arquivos de lead", value: "5", sub: "um .md por lead: auditoria, score e script" },
        { label: "Resumo semanal", value: "1", sub: "ranking, checklist e padrões" },
        { label: "Etapas automáticas", value: ETAPAS_SKILL.length, sub: "da busca ao script" },
      ]} />

      <div style={{ display: "grid", gap: 8, marginTop: 16 }}>
        <div className="alert-line warn" style={{ marginBottom: 0 }}>
          <strong>Regra CFM:</strong>&nbsp;nada de promessa de resultado clínico, antes/depois ou garantia de cura. O foco é crescimento digital.
        </div>
        <Explica title="Como invocar no Claude Code">
          <div style={MONO}>
            <div>/prospectar-leads-medicos [cidade] [especialidade] [quantidade]</div>
            <div>/prospectar-leads-medicos <span style={{ color: "var(--faint)" }}>→ padrões: São Paulo · ortopedista · 5 leads</span></div>
            <div>/prospectar-leads-medicos "Belo Horizonte" ortopedista 3</div>
            <div>/prospectar-leads-medicos "Campinas" dermatologista 5</div>
          </div>
          <div style={{ marginTop: 8 }}>
            Salva em <code>CLIENTES\PROSPECTOS\[especialidade]-[cidade]\semana-[data]\</code>. Arquivo da skill:{" "}
            <code>C:\Users\rcamp\.claude\skills\prospectar-leads-medicos.md</code>
          </div>
        </Explica>
      </div>

      <BlockHead title="Classificação por score" />
      <div className="klist">
        {SCORES.map((s) => (
          <div key={s.range} className="klist-row">
            <span className="minibar-n" style={{ width: 54, color: s.cor, fontWeight: 600 }}>{s.range}</span>
            <span className="txt"><strong style={{ fontWeight: 600 }}>{s.label}</strong><span style={{ color: "var(--muted)" }}> · {s.desc}</span></span>
          </div>
        ))}
      </div>

      <BlockHead title="Como funciona" sub={`${ETAPAS_SKILL.length} etapas automáticas. Clique para ver o detalhe.`} />
      <ExpandTable
        rows={ETAPAS_SKILL}
        rowKey={(e) => e.num}
        minWidth={420}
        columns={[
          { key: "num", label: "#", render: (e) => <span className="eyebrow">{e.num}</span> },
          { key: "titulo", label: "Etapa", render: (e) => <span className="name">{e.titulo}</span> },
        ]}
        detail={(e) => <div className="detail-grid"><Detalhe label="O que acontece">{e.desc}</Detalhe></div>}
      />

      <BlockHead title="Antes de abordar cada lead" sub="8 passos depois de receber os arquivos, antes de enviar qualquer mensagem." />
      <ExpandTable
        rows={PRE_ABORDAGEM}
        rowKey={(i) => i.ordem}
        minWidth={420}
        columns={[
          { key: "ordem", label: "#", render: (i) => <span className="eyebrow">{i.ordem}</span> },
          { key: "acao", label: "Passo", render: (i) => <span className="name">{i.acao}</span> },
        ]}
        detail={(i) => <div className="detail-grid"><Detalhe label="Como">{i.detalhe}</Detalhe></div>}
      />
    </div>
  );
}
